"use strict";

var _defineProperty = require("/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _cssinjs = require("@ant-design/cssinjs");

var uploadAnimateInlineIn = new _cssinjs.Keyframes('uploadAnimateInlineIn', {
  from: {
    width: 0,
    height: 0,
    margin: 0,
    padding: 0,
    opacity: 0
  }
});
var uploadAnimateInlineOut = new _cssinjs.Keyframes('uploadAnimateInlineOut', {
  to: {
    width: 0,
    height: 0,
    margin: 0,
    padding: 0,
    opacity: 0
  }
}); // =========================== Motion ===========================

var genMotionStyle = function genMotionStyle(token) {
  var _$concat;

  var componentCls = token.componentCls;
  var inlineCls = "".concat(componentCls, "-animate-inline");
  return [_defineProperty({}, "".concat(componentCls, "-wrapper"), (_$concat = {}, _defineProperty(_$concat, "".concat(inlineCls, "-appear, ").concat(inlineCls, "-enter, ").concat(inlineCls, "-leave"), {
    animationDuration: token.motionDurationSlow,
    animationTimingFunction: token.motionEaseInOutCirc,
    animationFillMode: 'forwards'
  }), _defineProperty(_$concat, "".concat(inlineCls, "-appear, ").concat(inlineCls, "-enter"), {
    animationName: uploadAnimateInlineIn
  }), _defineProperty(_$concat, "".concat(inlineCls, "-leave"), {
    animationName: uploadAnimateInlineOut
  }), _$concat)), uploadAnimateInlineIn, uploadAnimateInlineOut];
};

var _default = genMotionStyle;
exports.default = _default;